import React from 'react';
import {
  focusEditor,
  someNode,
  toggleNodeType,
  useEventPlateId,
  useEditorState,
} from '@udecode/plate-common';

import { ToolbarButton } from './ToolbarButton';

/**
 * Toolbar button to toggle the block of the node in selection.
 */
export const BlockToolbarButton = ({
  id,
  type,
  clear,
  inactiveType,
  ...props
}) => {
  const editor = useEditorState(useEventPlateId(id));

  return (
    <ToolbarButton
      active={!!editor?.selection && someNode(editor, { match: { type } })}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();

        toggleNodeType(editor, { activeType: type, inactiveType });
        setTimeout(() => {
          focusEditor(editor);
        }, 0);
      }}
      {...props}
    />
  );
};